import { ISVGProps } from '@alinta-digital/asg';
import React from 'react';

export const OktaCallbackErrorIllustration = (props: ISVGProps) => (
  <svg width="200" height="176" viewBox="0 0 200 176" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.1"
      d="M78.4167 166.417C78.4167 167 78.75 167.417 79.1667 167.667C81.4167 167.667 83.5833 167.75 85.6667 167.833H115.083C115.917 167.833 116.583 167.167 116.583 166.333C116.583 165.5 117.25 164.833 118.083 164.833H176.167C191 147.417 200 124.75 200 100C200 44.75 155.25 0 100 0C44.75 0 0 44.75 0 100C0 124.75 8.99999 147.333 23.8333 164.833H76.9167C77.75 164.917 78.4167 165.583 78.4167 166.417Z"
      fill="#00A7E6"
    />
    <path
      d="M143 88.75H156.833C157.5 88.75 158.083 89.3333 158.083 90V156.333H37.5V139.667V130.333V90C37.5 89.3333 38.0833 88.75 38.75 88.75H133.583"
      fill="white"
    />
    <path
      d="M70.0832 115H134.583V130.25H58.0833V115H63.4999"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M156.333 174.834H177.25C179.333 174.834 181.083 173.084 181.083 171V164.917H118.083C117.25 164.917 116.583 165.584 116.583 166.417C116.583 167.25 115.917 167.917 115.083 167.917H79.9167C79.0834 167.917 78.4167 167.25 78.4167 166.417C78.4167 165.584 77.75 164.917 76.9167 164.917H14.25V171C14.25 173.084 16 174.834 18.0833 174.834H144.5"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M51.5 80.417H33.75C31 80.417 28.75 82.667 28.75 85.417V164.917"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M166.667 164.917V85.417C166.667 82.667 164.417 80.417 161.667 80.417H63.5"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M37.5 130.333V90C37.5 89.3333 38.0833 88.75 38.75 88.75H133.583"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M143 88.75H156.833C157.5 88.75 158.083 89.3333 158.083 90V156.333H37.5V139.667"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M145.833 125.833C161.942 125.833 175 112.775 175 96.6667C175 80.5584 161.942 67.5 145.833 67.5C129.725 67.5 116.667 80.5584 116.667 96.6667C116.667 112.775 129.725 125.833 145.833 125.833Z"
      fill="#F26722"
    />
    <path
      d="M118 105.5C117.083 102.75 116.667 99.75 116.667 96.6667C116.667 80.5833 129.75 67.5 145.833 67.5C161.917 67.5 175 80.5833 175 96.6667C175 112.75 161.917 125.833 145.833 125.833C140.417 125.833 135.25 124.333 130.917 121.75"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M124.584 116.667C123.084 115.083 121.834 113.417 120.75 111.5"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M168.667 94.0837C168.75 94.917 168.833 95.7503 168.833 96.667C168.833 109.334 158.583 119.667 145.833 119.667C133.167 119.667 122.833 109.417 122.833 96.667C122.833 84.0003 133.083 73.667 145.833 73.667C156.417 73.667 165.333 80.8337 168 90.5003"
      fill="white"
    />
    <path
      d="M168.667 94.0837C168.75 94.917 168.833 95.7503 168.833 96.667C168.833 109.334 158.583 119.667 145.833 119.667C133.167 119.667 122.833 109.417 122.833 96.667C122.833 84.0003 133.083 73.667 145.833 73.667C156.417 73.667 165.333 80.8337 168 90.5003"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M145.833 99.917C147.628 99.917 149.084 98.4619 149.084 96.667C149.084 94.8721 147.628 93.417 145.833 93.417C144.039 93.417 142.583 94.8721 142.583 96.667C142.583 98.4619 144.039 99.917 145.833 99.917Z"
      fill="#EF5A3D"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path d="M145.833 93.3337V85.167" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M168.833 96.667H163" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M128.833 96.667H123" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M145.917 119.5V113.75" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M145.917 79.5V73.75" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M129.75 112.833L133.833 108.75" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M158 84.5003L162.083 80.417" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M129.75 80.417L133.833 84.5003" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M158 108.75L162.083 112.833" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path d="M148.75 98.167L162.084 102.917" stroke="#43363D" strokeWidth="1.0452" strokeMiterlimit="10" />
    <path
      d="M76.2499 126C74.3332 126 72.8333 124.417 72.8333 122.584C72.8333 120.667 74.4166 119.167 76.2499 119.167C78.0832 119.167 79.6666 120.75 79.6666 122.584C79.6666 123.917 78.9166 125.084 77.7499 125.667"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M87.0835 120.5C88.2501 119 90.4168 118.667 91.9168 119.833C93.4168 121 93.7502 123.167 92.5835 124.667C91.4168 126.167 89.2502 126.5 87.7502 125.333C86.6668 124.5 86.2502 123.167 86.4168 121.917"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M103.5 126C101.583 126 100.083 124.417 100.083 122.584C100.083 120.667 101.667 119.167 103.5 119.167C105.417 119.167 106.917 120.75 106.917 122.584C106.917 123.917 106.167 125.084 105 125.667"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path
      d="M114.333 120.5C115.5 119 117.667 118.667 119.167 119.833C120.667 121 121 123.167 119.833 124.667C118.667 126.167 116.5 126.5 115 125.333C113.917 124.5 113.5 123.167 113.667 121.917"
      stroke="#43363D"
      strokeWidth="1.0452"
      strokeMiterlimit="10"
    />
    <path d="M134.583 130.25H58.0833V131.583H134.583V130.25Z" fill="#43363D" />
  </svg>
);
